var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 209,
    viewBox: "0 0 205 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.296 47.8535C107.773 35.6855 105.108 23.6947 105.108 23.6947C103.022 11.2207 79.3866 -1.20498 66.365 0.139861C62.7814 -0.254732 59.1576 0.188167 55.7754 1.43637C52.3932 2.68458 49.3491 4.69785 46.8769 7.31505C44.4046 9.94031 42.5766 13.097 41.5378 16.5518C40.499 19.9984 40.2735 23.6464 40.8775 27.1977L42.0532 34.2279C42.0532 38.1577 42.2625 41.6286 42.335 44.0525C42.6491 55.23 32.4219 56.5506 28.4759 63.0172C24.53 69.4837 30.2315 73.5585 30.8918 81.9657C31.4475 89.3664 25.2548 90.4052 22.2591 98.9574C20.6485 109.032 30.312 106.817 34.9344 109.95C47.5373 110.538 64.231 107.751 64.231 107.751C64.231 107.751 140.814 117.213 119.104 75.3543C115.432 68.2677 99.0277 59.5061 103.296 47.8535Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0819 110.941C71.0819 110.941 148.197 113.896 123.023 74.026C118.796 67.3259 101.699 59.9656 104.985 47.9989C108.415 35.4927 104.751 23.8401 104.751 23.8401C101.619 11.5916 77.0168 1.20326 64.1562 3.6433",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.671 2.86138C66.6819 2.50705 64.6526 2.41852 62.6394 2.61179C59.7645 2.85338 56.97 3.66669 54.4092 4.99543C51.8484 6.32416 49.5694 8.14415 47.7173 10.3587C45.857 12.5652 44.4558 15.118 43.5861 17.8721C42.7244 20.6262 42.4104 23.5171 42.66 26.392L43.2801 33.0276C43.0143 36.6837 42.9741 39.9371 42.8694 42.208C42.4023 52.6768 32.626 53.2084 28.4465 58.9823C24.2671 64.7563 29.3807 68.9276 29.3968 76.8115C29.4129 84.6953 27.7862 87.4978 24.2188 91.5806",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6202 52.1405L54.8309 49.1367L50.8125 87.6056L79.6017 90.6093L83.6202 52.1405Z",
    fill: "#FFC89E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5313 72.1873L83.625 52.1195L65.3449 50.2109L58.7656 56.4681C62.5344 64.6257 70.531 70.3915 81.5313 72.1873Z",
    fill: "#FF7B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.942 64.0439C76.9221 64.5513 73.8378 64.4547 70.8582 63.7702C67.8787 63.0857 65.0601 61.8133 62.5717 60.0336C60.0834 58.2539 57.9655 56.0072 56.3468 53.4141C54.7201 50.8211 53.633 47.93 53.1257 44.9102L50.7098 30.5276C49.6951 24.4396 51.1366 18.1906 54.7201 13.1656C58.3117 8.14052 63.7475 4.7422 69.8355 3.71948C75.9316 2.70481 82.1727 4.14627 87.1977 7.73788C92.2308 11.3214 95.6291 16.7651 96.6438 22.8532L99.0596 37.2277C99.567 40.2395 99.4703 43.3318 98.7858 46.3114C98.1013 49.291 96.837 52.1095 95.0573 54.5979C93.2856 57.0862 91.0308 59.2041 88.4378 60.8228C85.8447 62.4414 82.9618 63.5366 79.942 64.0439Z",
    fill: "#FFC89E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9839 2.5705C54.2215 4.86559 44.864 17.4845 47.0463 30.7558L47.8516 35.7084C53.1746 37.939 59.0935 38.3336 64.6661 36.8277C70.2388 35.3218 75.1511 32.0039 78.63 27.3896L87.8828 14.9156C88.9941 13.4178 89.9363 11.7911 90.6852 10.0839C87.8103 7.07206 84.2267 4.80924 80.2727 3.49661C76.3107 2.18398 72.0909 1.8699 67.9839 2.5705Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7332 48.8953C56.171 49.9341 54.2625 50.3045 52.4264 49.9341C50.5984 49.5636 48.9798 48.4846 47.9409 46.9223L47.3047 45.9721C46.2739 44.4098 45.8954 42.5013 46.2659 40.6652C46.6363 38.8292 47.7234 37.2185 49.2777 36.1797C50.0507 35.6643 50.9205 35.31 51.8305 35.1329C52.7405 34.9557 53.6746 34.9557 54.5846 35.1329C55.4946 35.3181 56.3562 35.6804 57.1293 36.1958C57.8943 36.7112 58.5547 37.3796 59.0701 38.1527L59.7063 39.1029C60.7451 40.6652 61.1155 42.5737 60.745 44.4098C60.3746 46.2458 59.2955 47.8565 57.7332 48.8953Z",
    fill: "#FFC89E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5476 33.1249C95.5476 34.8644 94.6536 36.2817 93.5503 36.2817C92.4471 36.2817 91.5371 34.8724 91.5371 33.133C91.5371 31.3936 92.4311 29.9844 93.5343 29.9844C94.6376 29.9844 95.5395 31.3855 95.5476 33.1249Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.084 26.432C90.084 26.432 96.3652 24.2739 100.706 27.8655",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9496 34.1917C79.9496 35.9312 79.0637 37.3405 77.9524 37.3405C76.8411 37.3405 75.9473 35.9392 75.9473 34.1998C75.9473 32.4604 76.8331 31.0511 77.9444 31.043C79.0557 31.0349 79.9496 32.4523 79.9496 34.1917Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7441 28.6531C72.7441 28.6531 78.5826 25.4882 83.4626 28.3148",
    stroke: "black",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9512 30.5625C86.9512 30.5625 89.9146 38.2369 91.2434 40.5884C92.8539 43.5035 87.5229 44.3974 87.5229 44.3974",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4695 51.2367C87.6386 51.124 77.8059 47.7578 77.8059 47.7578C77.8059 47.7578 74.77 59.9661 87.4695 51.2367Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7812 38.5586C51.7812 38.5586 55.4051 39.4042 55.9285 44.8319",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2504 76.208L55.0916 81.2975C46.9823 83.5604 39.4851 87.6271 33.1716 93.1917C26.85 98.7563 21.8733 105.674 18.6038 113.437L2.49797 151.64C-8.10775 176.813 19.1756 201.149 42.972 187.733L75.8602 169.211L112.525 162.012L114.861 97.194C112.622 89.8739 107.726 83.6651 101.13 79.7836C94.543 75.9021 86.7316 74.6216 79.2504 76.2161V76.208Z",
    fill: "#01304A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.373 157.307L50.4766 134.219",
    stroke: "white",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.323 83.4531L91.8262 205.165",
    stroke: "#FF7B55",
    strokeWidth: 15.34
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.504 92.6586L180.163 63.3137C180.735 61.985 180.123 60.4468 178.794 59.8751L137.788 42.1908C136.468 41.619 134.921 42.2311 134.35 43.5598L121.699 72.9047C121.127 74.2334 121.739 75.7715 123.068 76.3433L164.065 94.0275C165.394 94.5993 166.932 93.9873 167.504 92.6586Z",
    stroke: "#FF7B55",
    strokeWidth: 15.34
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.977 167.935L86.3145 158.594",
    stroke: "#FF7B55",
    strokeWidth: 15.34
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.652 177.943L92.0156 172.926",
    stroke: "#FF7B55",
    strokeWidth: 15.34
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3321 187.951L77.6777 178.617",
    stroke: "#FF7B55",
    strokeWidth: 15.34
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.783 118.196C131.783 118.196 145.997 118.341 149.653 114.467C153.727 110.143 152.222 105.351 147.865 101.22L144.297 98.9492L141.269 105.649L131.783 118.196Z",
    fill: "#FFC89E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.682 128.099C127.682 128.099 136.145 128.099 140.679 126.005C146.912 123.122 149.054 116.341 148.104 116.164",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M125.404 135.22C128.456 135.108 131.476 134.576 134.391 133.658C138.901 132.168 141.212 128.955 140.681 126.008",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.39 133.662C134.39 133.662 133.27 138.285 126.74 139.96C116.198 142.657 103.467 138.832 103.467 138.832L69.9744 164.481C67.5344 166.349 64.6353 167.517 61.5832 167.879C58.5312 168.234 55.4469 167.758 52.6364 166.51C48.924 164.851 45.9203 161.912 44.1808 158.232C42.4414 154.552 42.079 150.372 43.15 146.442L44.2855 142.271C45.4613 137.963 48.2798 134.29 52.1291 132.044L90.0423 109.866L98.0308 102.691C103.692 97.6093 111.101 94.9115 118.703 95.1692L132.457 95.8457L126.884 108.279",
    fill: "#FFC89E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.626 101.877C148.691 101.515 152.902 105.799 152.806 108.867C152.62 114.947 148.618 115.213 148.618 115.213C148.562 117.588 147.781 119.891 146.388 121.816C145.002 123.741 143.062 125.198 140.823 126.004C140.122 126.269 141.153 130.932 134.3 134.33C132.875 135.039 133.495 139.066 124.733 140.773C116.632 142.271 108.265 141.328 100.703 138.067L115.714 102.199C115.714 102.199 125.015 109.608 133.132 109.318C144.479 108.939 147.917 105.807 148.626 101.877Z",
    fill: "#FFC89E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.573 104.555C142.573 104.555 142.034 108.042 136.51 108.968C125.767 110.755 120.992 107.051 119.703 105.424",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.783 118.195C131.783 118.195 145.997 118.34 149.653 114.466C153.727 110.142 152.439 104.279 146.319 99.7617",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M127.682 128.099C127.682 128.099 136.145 128.099 140.679 126.005C146.912 123.122 149.054 116.341 148.104 116.164",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.404 135.22C128.456 135.108 131.476 134.576 134.391 133.658C138.901 132.168 141.212 128.955 140.681 126.008",
    stroke: "#FF7B55",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8911 72.4062L55.0507 80.3464C50.2994 81.7476 45.7737 83.8012 41.5781 86.4345C48.0849 97.4187 61.8071 102.218 74.4019 97.169C76.085 96.4845 77.7036 95.647 79.2337 94.6565L81.8911 72.4062Z",
    fill: "#FFC89E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166.746 122.674L179.14 127.442L187.459 116.441L188.578 130.88L203.597 132.958L187.201 138.305L185.719 152.8L178.463 141.099L166.279 144.296L172.77 134.883L166.746 122.674Z",
    stroke: "#FFC89E",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M188.104 23.3164L190.206 27.1657L194.055 29.2675L190.206 31.3774L188.104 35.2267L185.994 31.3774L182.145 29.2675L185.994 27.1657L188.104 23.3164Z",
    stroke: "#FFC89E",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2383 75.6778C88.7612 74.7276 95.421 75.9435 101.187 79.1486C106.945 82.3536 111.503 87.3546 114.144 93.3943",
    stroke: "white",
    strokeWidth: 2.19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefDetails);
export default __webpack_public_path__ + "static/media/briefDetails.a31053d5e0ee5f1a65f4a4e64e3f4484.svg";
export { ForwardRef as ReactComponent };